var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_c('transition',{attrs:{"name":"vertical"}},[_c(_vm.cpComponet,{tag:"component"})],1),_c('Modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }